import { useQuery } from "@tanstack/react-query";
import { getGameById, getPicksByGameId, getPlayers } from "../../../api";

export const useGameDetailsQuery = (gameId: string) => {
  return useQuery({
    queryKey: ["game-details", gameId],
    queryFn: () => getGameById(gameId),
  });
};

/**
 * Gets all players (not just those in a game).
 */
export const usePlayersQuery = () => {
  return useQuery({
    queryKey: ["players"],
    queryFn: getPlayers,
  });
};

export const usePicksQuery = (gameId: string) => {
  return useQuery({
    queryKey: ["games", gameId, "picks"],
    queryFn: () => getPicksByGameId(gameId),
  });
};
